import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./index.css";

// Get the root element
const container = document.getElementById("root");
// Create a root
const root = createRoot(container);
// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
